import styled from "@emotion/styled";

export const WrapperHeaderStyled = styled.div`
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
  position: absolute;
  left: 0;
  width: calc(100% - 42px);
  top: 0;
  margin: 18px 21px;
  height: 20px;

  & > div:nth-of-type(1) {
    justify-self: start;
  }
  & > div:nth-of-type(2) {
    justify-self: center;
  }
  & > div:nth-of-type(3) {
    justify-self: end;
  }
`;

export const WrapperLogoStyled = styled.div`
  display: flex;
  justify-content: center;
  position: relative;
  z-index: 2;

  img {
    height: 20px;
    width: auto;
  }
`;

export const CloseButtonWrapper = styled.div`
  width: 15px;
  height: 15px;
  cursor: pointer;
  z-index: 2;
`;

export const BackButtonWrapper = styled.div`
  width: 16px;
  height: 12.5px;
  cursor: pointer;
  z-index: 2;
`;
